export const SMOKEHOUSE_ANALYTICS_EVENTS=Object.freeze([
  'smokehouse_onboarding_started',
  'smokehouse_onboarding_completed',
  'smokehouse_onboarding_skipped',
  'smokehouse_smoker_created',
  'smokehouse_smoker_updated',
  'smokehouse_smoker_archived',
  'smokehouse_default_smoker_changed',
  'smokehouse_thermometer_created',
  'smokehouse_thermometer_updated',
  'smokehouse_thermometer_archived',
  'smokehouse_wood_inventory_added',
  'smokehouse_wood_inventory_updated',
  'smokehouse_wood_inventory_archived',
  'smokehouse_wood_favourite_added',
  'smokehouse_wood_favourite_removed'
]);

const EVENT_SET=new Set(SMOKEHOUSE_ANALYTICS_EVENTS);
const SAFE_KEYS=new Set([
  'step',
  'smoker_type',
  'temperature_control',
  'cold_smoking',
  'thermometer_type',
  'channel_count',
  'wood_source',
  'quantity_unit',
  'has_quantity',
  'active_count',
  'offline'
]);

function safeEnum(value,{fallback='unknown',max=64}={}){
  const text=String(value??'').trim().toLowerCase();
  return /^[a-z][a-z0-9_]{0,63}$/.test(text)&&text.length<=max?text:fallback;
}

function safeCount(value,{max=10000}={}){
  const number=Number(value);
  if(!Number.isFinite(number))return 0;
  return Math.max(0,Math.min(max,Math.trunc(number)));
}

function sanitizeProperties(properties={}){
  const result={};
  for(const [key,value] of Object.entries(properties||{})){
    if(!SAFE_KEYS.has(key))continue;
    if(key==='channel_count'||key==='active_count')result[key]=safeCount(value);
    else if(key==='has_quantity'||key==='offline')result[key]=Boolean(value);
    else result[key]=safeEnum(value);
  }
  return Object.freeze(result);
}

export function createSmokehouseAnalytics({analytics}={}){
  if(typeof analytics?.track!=='function')throw new TypeError('analytics.track is required');

  function track(name,properties={}){
    if(!EVENT_SET.has(name))throw new TypeError('Unsupported Smokehouse analytics event');
    return analytics.track(name,sanitizeProperties(properties));
  }

  return Object.freeze({
    track,
    onboardingStarted:step=>track('smokehouse_onboarding_started',{step}),
    onboardingCompleted:()=>track('smokehouse_onboarding_completed'),
    onboardingSkipped:step=>track('smokehouse_onboarding_skipped',{step}),
    smokerCreated:properties=>track('smokehouse_smoker_created',properties),
    smokerUpdated:properties=>track('smokehouse_smoker_updated',properties),
    smokerArchived:properties=>track('smokehouse_smoker_archived',properties),
    defaultSmokerChanged:activeCount=>track('smokehouse_default_smoker_changed',{active_count:activeCount}),
    thermometerCreated:properties=>track('smokehouse_thermometer_created',properties),
    thermometerUpdated:properties=>track('smokehouse_thermometer_updated',properties),
    thermometerArchived:properties=>track('smokehouse_thermometer_archived',properties),
    woodInventoryAdded:properties=>track('smokehouse_wood_inventory_added',properties),
    woodInventoryUpdated:properties=>track('smokehouse_wood_inventory_updated',properties),
    woodInventoryArchived:properties=>track('smokehouse_wood_inventory_archived',properties),
    woodFavouriteAdded:()=>track('smokehouse_wood_favourite_added'),
    woodFavouriteRemoved:()=>track('smokehouse_wood_favourite_removed')
  });
}
